import { ArticleManager } from '@article/manager/article.manager';
import { ProjectModel } from '../../../model/project.model';
import { CodingArticleUtils } from '@article/util/coding-article.utils';
import { AlertHelper } from '@shared/alert/alert.helper';
import { CodingArticleProcessor } from './coding-article.processor';
import { AddCodingArticleProcessor } from './add-coding-article.processor';
import { Injectable } from '@angular/core';
import { ConnectionInfoService } from '@3d-scene/model3d/service/connection-info.service';

@Injectable({ providedIn: "root" })
export class AddCodingArticleProcessorInitializer {
  constructor(
    private articleManager: ArticleManager,
    private projectModel: ProjectModel,
    private codingArticleUtils: CodingArticleUtils,
    private alertHelper: AlertHelper,
    private connectionInfoService: ConnectionInfoService,
    private codingArticleProcessor: CodingArticleProcessor,
    private addCodingArticleProcessor: AddCodingArticleProcessor
  ) {}

  public initialize() {
    this.addCodingArticleProcessor.initialize(
      this.articleManager,
      this.projectModel,
      this.codingArticleUtils,
      this.alertHelper,
      this.connectionInfoService,
      this.codingArticleProcessor
    );
  }
}
